import { defineMessages } from 'react-intl';

import { addStyling } from '@plone/volto/helpers/Extensions/withBlockSchemaEnhancer';

const messages = defineMessages({
  paddingVertical: {
    id: 'paddingVertical',
    defaultMessage: 'Vertical padding',
  },
});

export const paddingVerticalStyleSchema = ({ schema, formData, intl }) => {
  addStyling({ schema, intl });
  schema.properties.styles.schema.fieldsets[0].fields = [
    ...schema.properties.styles.schema.fieldsets[0].fields,
    '--padding-vertical',
  ];
  schema.properties.styles.schema.properties['--padding-vertical'] = {
    title: intl.formatMessage(messages.paddingVertical),
    default: 'initial',
    choices: [
      ['initial', 'initial'],
      ['0rem', '0rem'],
      ['5rem', '5rem'],
    ],
  };
  schema.properties.styles.schema.properties['--padding-vertical'].actions = [
    'initial',
    '0rem',
    '5rem',
  ];

  return schema;
};
